import React from 'react';
import PropTypes from 'prop-types';

const PagingContainer = (props) => {
	return <div className="d-flex justify-content-end">{props.children}</div>;
};

export default PagingContainer;

PagingContainer.propTypes = {
	children: PropTypes.node
};

PagingContainer.defaultProps = {
	children: null
};
